import { DocumentAutoCompleteValue } from 'components/form-fields/auto-complete-fields/DocumentAutoComplete';
import { IEventTypeMultiSelectAutoComplete } from 'components/form-fields/auto-complete-fields/EventTypeMultiSelectAutoComplete';
import { AthletePackage } from 'types';

export interface AttendanceRuleFormValue {
  attendanceRuleId?: string;
  name?: string;
  isInfiniteSessions: boolean;
  credits: number | null;
  intervalCount: number | null;
  interval: 'day' | 'week' | 'month' | 'year' | null;
  validityIntervalCount: number | null;
  validityInterval: 'day' | 'week' | 'month' | 'year'  | null;
  delayIntervalCount: number | null;
  delayInterval: 'day' | 'week' | 'month' | 'year' | null;
  kiloClassTypes: Array<IEventTypeMultiSelectAutoComplete>;
  appointmentTypes: Array<IEventTypeMultiSelectAutoComplete>;
  perOrPack: string;
  delayStart: boolean;
  oldKiloClassTypeSet: Set<string>;
  oldAppointmentTypeSet: Set<string>;
  eventTypeState: 'same' | 'incompatible' | 'superset';
}

export interface TimeBasedPackageFormValues {
  packageId: string;
  name: string;
  description: string;
  packageValidityAmount: number;
  packageValidityPeriod: string;
  autoRenew: string;
  packageCategory: string;
  contract: DocumentAutoCompleteValue;
  contractOnRenew: boolean;
  athleteStatusOnStart: Exclude<AthletePackage['athleteStatusOnStart'], null> | 'No status change';
  athleteStatusOnEnd: Exclude<AthletePackage['athleteStatusOnEnd'], null> | 'No status change';
  attendanceRules: Array<AttendanceRuleFormValue>;
  allowProration: string;
  allowRollover: 'On' | 'Off';
  rolloverExpires: 'Expires' | 'Do Not Expire';
  rolloverInterval: 'day' | 'week' | 'month' | 'year' | null;
  rolloverIntervalCount: number | null;
  isRolloverLimited: 'Limited to' | 'Unlimited';
  rolloverLimit: number | null;
  limitQuantity: 'On' | 'Off';
  maxSalesAllowed: number | null;
  oneTimePurchase: 'On' | 'Off';
  setSpecificStartDate: 'On' | 'Off';
  startDate: Date | null;
  invoiceTrigger: 'at_package_start' | 'immediately' | null;
  includeFollowUpPackage: boolean;
  successorPackage: string | null;
  successorBillingPlan: string | null;
  clickToCancelEnabled: 'On' | 'Off';
}

export interface CreditBasedPackageFormValues extends Omit<
  TimeBasedPackageFormValues,
  | 'allowProration'
  | 'allowRollover'
  | 'rolloverExpires'
  | 'rolloverInterval'
  | 'rolloverIntervalCount'
  | 'isRolloverLimited'
  | 'rolloverLimit'
  | 'includeFollowUpPackage'
  | 'successorPackage'
  | 'successorBillingPlan'
  | 'limitQuantity'
  | 'maxSalesAllowed'
  | 'setSpecificStartDate'
  | 'startDate'
  | 'invoiceTrigger'
>{}

export enum Period {
  week = 'week',
  day = 'day',
  month = 'month',
  year = 'year',
}

export const PERIODOPTIONS = [
  {
    value: Period.day,
    label: `${Period.day.charAt(0).toUpperCase() + Period.day.slice(1)}s`,
  },
  {
    value: Period.week,
    label: `${Period.week.charAt(0).toUpperCase() + Period.week.slice(1)}s`,
  },
  {
    value: Period.month,
    label: `${Period.month.charAt(0).toUpperCase() + Period.month.slice(1)}s`,
  },
  {
    value: Period.year,
    label: `${Period.year.charAt(0).toUpperCase() + Period.year.slice(1)}s`,
  },
];
